import React from "react";
import { useParams } from "react-router-dom";
import {
  fetchData,
  fetchCompanyInvestment,
  fetchCompanyDataList,
} from "../api";
import { useQuery, useInfiniteQuery } from "react-query";
import LoadingButton from "../components/LoadingButton/LoadingButton";
import Spinner from "../components/Spinner/Spinner";
import Image from "../components/Image/Image";
import Grid from "../components/Grid/Grid";
import Table from "../components/Table/Table";
import parse from "html-react-parser";
import formatNumber from "../helpers/formatNumber";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";

const columns = [
  {
    label: "",
    field: "title",
    colWidth: "100%",
    rowValue: (val, row) => (
      <div className="dividend-payment-container">
        <Link to={`/knowledge/crypto/${row?.key}/${row.title}`}>
          <div className="dividend-payment-text-container">
            <div className="dividend-payment-date text-muted">
              {moment(row?.releaseDate).format("DD.MM.YYYY")}
            </div>
            <div className="dividend-payment-name text-light">
              {val || row?.ticker}
            </div>
          </div>
        </Link>
      </div>
    ),
  },
];

function CryptoInfo() {
  const { id } = useParams();
  //* states
  const [showProfitAsPercentage, setShowProfitAsPercentage] =
    React.useState(false);

  //* data fetching
  const { data, isLoading } = useQuery(["crypto-info"], () =>
    fetchData("crypto", id)
  );
  const { data: myInvestment } = useQuery(["myinvestment"], () =>
    fetchCompanyInvestment(id)
  );

  const limit = 6;

  const {
    data: cryptoArticle,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ["cryptoArticles", id, limit],
    async ({ pageParam = 0 }) => {
      return fetchCompanyDataList("cryptoblog", id, pageParam, limit);
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        // Wenn weniger als limit Elemente kamen, ist Schluss
        if (lastPage.length < limit) return undefined;
        return allPages.length; // nächste page
      },
    }
  );
  const allItems = cryptoArticle?.pages.flat() || [];

  //* functions
  const profit = React.useMemo(() => {
    if (data?.price >= 0 && myInvestment?.investment)
      return myInvestment?.shares > 0
        ? myInvestment?.shares * 1 * data?.price - myInvestment?.investment
        : myInvestment.investment * -1;
  }, [data?.price, myInvestment?.investment, myInvestment?.shares]);

  if (isLoading) return <Spinner />;

  return (
    <div className="article-main">
      <Grid>
        <div
          style={{
            background: "linear-gradient(to right, #343A40, #525252)",
            width: "96vw",
          }}
        >
          <Grid>
            <a href={data?.homepage || ""} target="_blank">
              {data?.logo && (
                <Image
                  width={100}
                  height={100}
                  source={data?.logo}
                  className="table-thumbnail stockinfo-icon"
                />
              )}
            </a>

            <div
              style={{
                marginTop: "10px",
                marginLeft: "20px",
                width: "50%",
                overflow: "hidden",
              }}
            >
              <h4 className="text-light text-truncate">{data?.name}</h4>
              <span
                className="stockinfo-keyfacts-value"
                style={{
                  fontSize: "14px",
                  color: profit < 0 ? "tomato" : "lawngreen",
                }}
                onClick={() => setShowProfitAsPercentage((prev) => !prev)}
              >
                <FontAwesomeIcon icon={profit < 0 ? faCaretDown : faCaretUp} />
                &nbsp;
                {showProfitAsPercentage
                  ? `${formatNumber(
                      (
                        (profit / myInvestment?.investment) *
                          (profit < 0 ? -100 : 100) || 0
                      ).toFixed(2)
                    )} %`
                  : `${formatNumber(
                      (profit < 0 ? profit * -1 : profit || 0).toFixed(2)
                    )} €`}
              </span>
            </div>
          </Grid>
        </div>
        {/* Personal data */}
        <Grid>
          <div className="col-4 text-center">
            <p className="stockinfo-keyfacts-label text-muted">Gesamtwert €</p>
            <p className="stockinfo-keyfacts-value text-light">
              {myInvestment?.investment && myInvestment?.shares > 0
                ? `${formatNumber(
                    (myInvestment?.shares * 1 * data.price).toFixed(2)
                  )}`
                : "-"}
            </p>
          </div>
          <div className="col-4 text-center">
            <p className="stockinfo-keyfacts-label text-muted">Anteile</p>
            <p className="stockinfo-keyfacts-value text-light">
              {myInvestment?.shares
                ? `${formatNumber((myInvestment?.shares || 0).toFixed(2))}`
                : "-"}
            </p>
          </div>
          <div className="col-4 text-center">
            <p className="stockinfo-keyfacts-label text-muted">Staking</p>
            <p
              className="stockinfo-keyfacts-value"
              style={{
                color: myInvestment?.staking ? "lawngreen" : "white",
              }}
            >
              {myInvestment?.staking
                ? `${formatNumber((myInvestment?.staking).toFixed(2))}`
                : "-"}
            </p>
          </div>
        </Grid>
        {/* Description */}
        <div className="article-main">
          <h6 className="text-muted">Beschreibung</h6>
          <div id="meta-description" className={`text-light text-left`}>
            {data?.description && parse(data?.description)}
          </div>
        </div>
        {/* Article */}
        {allItems?.length > 0 && (
          <div className="article-main">
            <h6 className="text-muted" style={{ marginBottom: "-20px" }}>
              Artikel
            </h6>
            <Table data={allItems} columns={columns} />
            {hasNextPage && (
              <div className="text-center mt-6">
                <LoadingButton
                  onClick={() => fetchNextPage()}
                  loading={isFetchingNextPage}
                />
              </div>
            )}
          </div>
        )}
      </Grid>
    </div>
  );
}

export default CryptoInfo;
